import { useEffect } from "react";
import Routes from "./Routes";
import OneSignal from "react-onesignal";

function App() {
  useEffect(() => {},
  [localStorage.getItem("level")]);

  useEffect(() => {
    const initOneSignal = async () => {
      try {
        // Ensure this code runs only on the client side
        if (import.meta.env.VITE_BUSINESS_PREVIEW === "1") return;
        if (typeof window !== "undefined") {
          // Initialize OneSignal
          await OneSignal.init({
            appId: `${import.meta.env.VITE_SIGNAL_APP_ID}`,
            notifyButton: {
              enable: true,
            },
            serviceWorkerPath: "OneSignalSDKWorker.js",
            allowLocalhostAsSecureOrigin: true,
          });

          // Handle user login based on owner status
          if (localStorage.getItem("is_owner") === "true") {
            const channelId = localStorage.getItem("staff_id");
            if (channelId) {
              const uniqueUserId = "0" + channelId;

              // Await login and tag addition
              await OneSignal.login(uniqueUserId);
              OneSignal.User.addTag("userId", uniqueUserId);
            }
          } else {
            const staffId = localStorage.getItem("staff_id");
            if (staffId) {
              // Await login and tag addition
              await OneSignal.login(staffId);
              OneSignal.User.addTag("userId", staffId);
            }
          }
        }
      } catch (error) {
        console.error("OneSignal initialization or login error:", error);
      }
    };

    initOneSignal();
  }, [OneSignal.User.PushSubscription.id]);

  return <Routes />;
}

export default App;
